import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[appTrocarValorSimNao]'
})
export class TrocarValorSimNaoDirective {


    @Input() campoSimNao: Boolean;

    constructor( private _elementRef: ElementRef) {

    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/directives/troca-valor-sim-nao.directive.ts